interface IParseDate {
	input: string;
	format?: string;
}

export const parseDate = ({ input, format = 'yyyy-mm-dd' }: IParseDate) => {
	const fmt = {};
	const parts = input.match(/(\d+)/g);
	let i = 0;
	// extract date-part indexes from the format
	format.replace(/(yyyy|dd|mm)/g, function (part) {
		fmt[part] = i++;
	});

	return new Date(parts[fmt['yyyy']], parts[fmt['mm']] - 1, parts[fmt['dd']]);
};
